module.exports = __webpack_public_path__ + "img/theme11.234e9701.png";